const images = {
    logoNav: 'https://project-static-assets.s3.amazonaws.com/SplitSpreadsheets/Logo.png',
    logoIcon: 'https://project-static-assets.s3.amazonaws.com/SplitSpreadsheets/LogoIcon.png',
};

export default images